import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

export default class Post extends Component {

  constructor(props) {
    super(props)
    this.state = {
      opened: false
    };
  }

  close = () => {
    this.setState({
      opened: false
    });
  }

  render() {
		const { post } = this.props
		const date = post.created_at || post.date || post.published || post.dateadded || post.pub_date || post.pubDate || '';
		let datum = date === undefined || date === '' ? '' : moment(date).fromNow();
		let company = post.company_name || post.company || post.companyname || (post.company && post.company.name) || '';
    return (
      <li className={post.sponsored ? 'job sponsored' : 'job'} onClick={() => { this.props.onClick(post.id)}}>
        {this.state.opened && <span onClick={this.close} className="close">x</span>}
        <h3>{post.title || post.position}</h3>
        {company !== '' && <h4>Company: {company}</h4>}
				<div className="time">{datum}</div>
      </li>
    )
  }
}

Post.propTypes = {
  post: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/Post.js